import axios from '@/utils/axios'

const rootUrl = 'masterdata/website/client/'
const api = {
  Page: rootUrl + 'page',
  Add: rootUrl + 'add',
  Edit: rootUrl + 'edit',
  Detail: rootUrl + 'detail',
  LevelList: rootUrl + 'levelList',
  TitleSortList: rootUrl + 'titleSortList',
  TitleSortDetail: rootUrl + 'titleSortDetail',
  AllTitleSortDetail: rootUrl + 'allTitleSortDetail',
  TitleSortEdit: rootUrl + 'titleSortEdit',
  AllTitleSortEdit: rootUrl + 'allTitleSortEdit',
  SearchMap: rootUrl + 'searchMap',
  BrandChainList: rootUrl + 'brandChainList',
  RelationClientPage: rootUrl + 'relationClientPage',
  ClientType: 'masterdata/website/export/clientType',
  SyncClientType: 'masterdata/website/export/synClientType',
  TitleSortDownloadDetail:
    'masterdata/website/title_sort/titleSortDownloadDetail',
  TitleSortDownloadEdit: 'masterdata/website/title_sort/titleSortDownloadEdit',
  agreementGoodsList: rootUrl + 'agreementGoodsList',
}
/**
 *  协议关联产品
 */
export function agreementGoodsList(parameter) {
  return axios.formRequest.post(api.agreementGoodsList, parameter)
}
/**
 * 档案翻页列表接口
 */
export function page(parameter) {
  return axios.formRequest.post(api.Page, parameter)
}

/**
 * 档案添加接口
 */
export function add(parameter) {
  return axios.formRequest.post(api.Add, parameter)
}
/**
 * 档案编辑接口
 */
export function edit(parameter) {
  return axios.formRequest.post(api.Edit, parameter)
}
/**
 * 档案等级列表接口
 */
export function levelList(cls) {
  return axios.formRequest.post(api.LevelList, {
    cls,
  })
}

/**
 * 标题自定义列表
 */
export function titleSortList(cls, is_width) {
  return axios.formRequest.post(api.TitleSortList, {
    cls,
    is_width 
  })
}

/**
 * 全部档案自定义列表
 */
export function AlltitlesortDetail() {
  return axios.formRequest.post(api.AllTitleSortDetail, {})
}

/**
 * 标题自定义详情
 */
export function titleSortDetail(cls) {
  return axios.formRequest.post(api.TitleSortDetail, {
    cls,
  })
}
/**
 * 标题自定义排序
 */
export function titleSortEdit(cls, title_sort_json) {
  return axios.formRequest.post(api.TitleSortEdit, {
    cls,
    title_sort_json,
  })
}

/**
 * 全部档案标题自定义排序
 */
export function allTitleSortEdit(title_sort_json) {
  return axios.formRequest.post(api.AllTitleSortEdit, {
    title_sort_json,
  })
}

/**
 * 导出表头排序详情
 */
export function titleSortDownloadDetail(cls) {
  return axios.formRequest.post(api.TitleSortDownloadDetail, {
    cls,
  })
}

/**
 * 导出表头排序编辑
 */
export function titleSortDownloadEdit(
  cls,
  title_sort_json,
  function_name,
  third_title_json,
) {
  return axios.formRequest.post(api.TitleSortDownloadEdit, {
    cls,
    title_sort_json,
    function_name,
    third_title_json,
  })
}

/**
 * 档案详情接口
 */
export function detail(client_id, type, operate) {
  let parameter = {
    client_id,
  }
  //医生
  if (type == 5) {
    parameter.is_edit = 1
  }
  if (operate) {
    parameter.operate = operate
  }
  return axios.formRequest.post(api.Detail, parameter)
}
/**
 * 逆地址解析接口
 */
export function searchMap(address, client_id = '') {
  return axios.formRequest.post(api.SearchMap, {
    address,
    client_id,
  })
}

/**
 * 品牌关联连锁总部列表接口
 */
export function brandChainList(brand_id, client_name) {
  return axios.formRequest.post(api.BrandChainList, {
    brand_id,
    client_name,
  })
}

/**
 * 连锁总部关联门店接口
 */
export function relationClientPage(cls, client_id, page, field_id) {
  return axios.formRequest.post(api.RelationClientPage, {
    cls,
    client_id,
    page,
    field_id,
  })
}

/**
 * 档案类型变更模版下载
 */
export function clientTypeExport(parameter) {
  return axios.formRequest.post(api.ClientType, parameter)
}
/**
 * 档案类型变更模版下载异步
 */
export function clientTypeExportSync(parameter) {
  return axios.formRequest.post(api.SyncClientType, parameter)
}

/**
 * 科室列表
 */
export function standardDepartmentlist() {
  return axios.formRequest.post(
    'masterdata/website/standard_department/standardDepartmentlist',
    {},
  )
}

/**
 * 医生职位
 */
export function doctorPositionList() {
  return axios.formRequest.post(
    'masterdata/website/client/doctorPositionList',
    {},
  )
}

/**
 * 医生职称
 */
export function doctorTitleList() {
  return axios.formRequest.post('masterdata/website/client/doctorTitleList', {})
}

/**
 * 获取联系人字段
 */
export function getContactField(cls) {
  return axios.formRequest.post('crm/website/visit/getContactField', {
    cls,
  })
}

/**
 * 档案类型变更模版下载
 */
// export function keepRecordExport(parameter) {
//   return axios.formRequest.post(
//     'masterdata/website/export/keepRecord',
//     parameter
//   );
// }

/**
 * 代理商等级列表
 */
export function agentLevelList() {
  return axios.formRequest.post('masterdata/website/Setting/agentLevelList', {})
}

/**
 * 代理关系查看接口
 */
export function agencyRelation(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/agencyRelation',
    parameter,
  )
}

/**
 * 根据名称查地址经纬度
 */
export function searchMapByName(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/searchMapByName',
    parameter,
  )
}

/**
 * 批量删除档案
 * client_ids
 */
export function delClient(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/delClient',
    parameter,
  )
}

/**
 * 判断档案是否有流向
 * client_ids
 */
export function haveFlowClient(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/haveFlowClient',
    parameter,
  )
}

/**
 * 档案更新字段选择
 *
 */
export function updateList(cls) {
  return axios.formRequest.post('masterdata/website/client/updateList', {
    cls,
  })
}

/**
 * 流向匹配档案
 *
 */
export function matchClient(parameter) {
  return axios.formRequest.post('flow/website/flow/matchClient', parameter)
}

/**
 *  编辑选择档案控件的选择值
 */
export function relationClientList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/relationClientList',
    parameter,
  )
}

/**
 * 匹配平台库接口
 *
 */
export function matchPlatformClient(parameter) {
  return axios.formRequest.post(
    'flow/website/flow/matchPlatformClient',
    parameter,
  )
}

/**
 * 导出康恩贝关联关系模板
 *
 */
export function exportKnbRelationTemplate(parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportKnbRelationTemplate',
    parameter,
  )
}

/**
 * 导出康恩贝关联关系
 *
 */
export function exportKnbRelation(parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportKnbRelation',
    parameter,
  )
}

/**
 * 康恩贝关联关系列表
 *
 */
export function knbRelationPage(parameter) {
  return axios.formRequest.post(
    'masterdata/website/knb_relation/page',
    parameter,
  )
}

/**
 * 康恩贝关联关系列表
 *
 */
export function getClientPage(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getClientPage',
    parameter,
  )
}

/**
 * 匹配企业库
 *
 */
export function matchAliasClient(parameter) {
  return axios.formRequest.post('flow/website/flow/matchAliasClient', parameter)
}

/**
 * 导出sass关联关系模板
 *
 */
export function exportRelationCustomTempLate(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportRelationCustomTempLate',
    parameter,
  )
}
/**
 * 导出sass关联关系
 *
 */
export function exportRelationCustom(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportRelationCustom',
    parameter,
  )
}
/**
 * 导出数据关系
 *
 */
export function exportRelationCustom2(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportRelationCustom2',
    parameter,
  )
}

/**
 * 根据名称搜索档案 (平台库)
 *
 */
export function matchPlatformClientt(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/matchPlatformClient',
    parameter,
  )
}

/**
 * 根据名称搜索档案 (企业库库)
 *
 */
export function matchClientt(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/matchClient',
    parameter,
  )
}

/**
 * 档案操作配置
 *
 */
export function clientMatchDetail(parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/clientMatchDetail',
    parameter,
  )
}

/**
 * 保存档案操作配置
 *
 */
export function clientMatch(parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/clientMatch',
    parameter,
  )
}

/**
 * 协议主体下载模板
 *
 */
export function exportBatchModel(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/exportBatchModel',
    parameter,
  )
}

/**
 * 产品政策下载模板
 *
 */
export function exportBatchGoods(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/exportBatchGoods',
    parameter,
  )
}

/**
 * 档案标签列表
 *
 */
export function clientLabelList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/clientLabelList',
    parameter,
  )
}

/**
 * 根据档案类型获取客户形态列表
 * @param parameter
 * @returns {*}
 */
export function getFormTextListByCls(cls) {
  return axios.formRequest.post(
    'masterdata/website/client/getFormTextListByCls',
    {
      cls,
    },
  )
}


/**
 * 获取这档案类型有没有开这个字段
 *
 */
 export function getListByCls(parameter) {
  return axios.formRequest.post(
    'masterdata/website/field/getListByCls',
    parameter,
  )
}



/**
 * 更新定级问卷下载模板
 *
 */
export function downloadDoctorQuestionLevelUpdateTemplate(parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/downloadDoctorQuestionLevelUpdateTemplate',
    parameter,
  )
}


/**
 * 获取筛选项
 *
 */
 export function getFieldTitleOptions(parameter) {
  return axios.formRequest.post(
    'masterdata/website/field/getFieldTitleOptions',
    parameter,
  )
}

/**
 * 获取窗口期导出提示数据
 */
export function getExportTipsData(parameter) {
  return axios.formRequest.post(
    '/masterdata/website/client_goods_quarter_change/getExportTipsData',
    parameter
  )
}

/**
 * 获取窗口期导出提示数据
 */
export function exportChangeData(parameter) {
  return axios.formRequest.post(
    '/masterdata/website/client_goods_quarter_change/exportChangeData',
    parameter
  )
}